import * as React from 'react';

import * as styles from './styles.css';

interface ISpecialProjectBannerSkeletonProps {
  children: React.ReactNode;
  dataName?: string;
}

export function SpecialProjectBannerSkeleton({ children, dataName }: ISpecialProjectBannerSkeletonProps) {
  return (
    <div className={styles['container']} data-name={dataName}>
      <div className={styles['wrapper']}>
        <div className={styles['preview']} />
        <div className={styles['content']}>
          {[1, 2].map(item => (
            <div key={item} className={styles['line']} />
          ))}
        </div>
        <div className={styles['layout']}>{children}</div>
      </div>
    </div>
  );
}
